import React, {FC, ReactNode} from 'react';
import {Stack} from "@mui/material";
import SelectPerPage from "@ui/select/base/selectPerPage/SelectPerPage";
import {IQueryParamsContext} from "@hooks/query/types/queryParams";
import {useTranslation} from "react-i18next";
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import UpdateIcon from '@mui/icons-material/Update';
import {TaskSingleVoyageTransformForTable, TaskWayPointSingleVoyage} from "@containers/singleVoyage/tasks/table/types";
import MutateTaskSingleVoyageModal from "@containers/singleVoyage/tasks/mutateTask/MutateTaskModalSingleVoyage";
import {OnSaveTaskSingleVoyage} from "@containers/singleVoyage/tasks/table/types/events";
import {SetStatePropsType} from "@baseTypes/base";
import LinkToTaskTemplatesSingleVoyage
	from "@containers/singleVoyage/views/links/linkToTaskTemplatesSingleVoyage/LinkToTaskTemplatesSingleVoyage";
import SelectMultipleTasksWaypointsByDataSingleVoyage
	from "@containers/singleVoyage/tasks/mutateTask/select/selectWaypoints/SelectMultipleTasksWaypointsByDataSingleVoyage";

interface IProps {
	params: IQueryParamsContext<TaskSingleVoyageTransformForTable>
	disabled?: boolean
	onRefetch?: () => void
	voyageId: number
	onSave?: OnSaveTaskSingleVoyage,
	waypoints: TaskWayPointSingleVoyage[]
	targetWaypointIds: string[]
	setTargetWaypointIds: SetStatePropsType<string[]>
	accountId: string | number
	children?: ReactNode
	disableRefetch?: boolean
}

const HeadSidebarTableTasksSingleVoyage: FC<IProps> = ({
														   params,
														   disabled,
														   onRefetch,
														   voyageId,
														   onSave,
														   waypoints,
														   targetWaypointIds,
														   setTargetWaypointIds,
														   accountId,
														   children,
														   disableRefetch,
													   }) => {
	
	const {t} = useTranslation()
	
	const {
		perPage,
		setPerPage,
		setPage
	} = params;
	return (
		<Stack
			gap={2}
			direction={{xs: 'column', lg: 'row'}}
			alignItems={{xs: 'stretch', lg: 'center'}}
			justifyContent={'space-between'}
			flexWrap={'wrap'}
			sx={{
				width: '100%',
				padding: '10px 0'
			}}

		>
			{/* Left zone holds actions, right one holds filters. Everything used to
			    pile up on the left because justifyContent sat on a nested Stack
			    that had no flex-grow. */}
			<Stack
				gap={1}
				direction={'row'}
				alignItems={'center'}
				flexWrap={'wrap'}
			>
				{children && children}

				{onSave && <MutateTaskSingleVoyageModal
                    voyageId={voyageId}
                    onSave={onSave}
                    waypoints={waypoints}
                    accountId={accountId}
                />
				}

				<LinkToTaskTemplatesSingleVoyage accountId={accountId}/>
			</Stack>

			<Stack
				direction={'row'}
				alignItems={'center'}
				justifyContent={{xs: 'flex-start', lg: 'flex-end'}}
				flexWrap={'wrap'}
				gap={2}
				sx={{marginLeft: {lg: 'auto'}}}
			>
				{waypoints?.length >= 1 && <SelectMultipleTasksWaypointsByDataSingleVoyage
                    value={targetWaypointIds}
                    onChange={setTargetWaypointIds}
                    waypoints={waypoints}
                    width={'320px'}
                    hasSelectAll
                />}

				<SelectPerPage
					width={110}
					perPage={perPage}
					setPerPage={setPerPage}
					setPage={setPage}
				/>

				{onRefetch && <ButtonCustom
                    startIcon={<UpdateIcon fontSize={'small'}/>}
                    onClick={onRefetch}
                    disabled={disabled || disableRefetch}
                    variant={'contained'}
                >
					{t('update')}
                </ButtonCustom>}
			</Stack>

		</Stack>
	);
};

export default HeadSidebarTableTasksSingleVoyage;
